// extracted by mini-css-extract-plugin
export default {"container":"accountDetails_container__EB3I9"};